/**
 * Order-number display helper.
 *
 * Natively-generated retail + wholesale order numbers are stored WITHOUT
 * a leading `#` (e.g. `RO-00001`, `WO-00042`, `EQL-10247`).
 *
 * Historical Shopify-imported retail orders, however, carry Shopify's
 * `Name` column verbatim — which DOES include the `#` (e.g. `#19265`).
 * We keep the raw value in the DB (so customer-facing emails and
 * cross-references to the old Shopify admin still match) and normalise
 * only at render time.
 *
 * Render with this helper everywhere we'd otherwise write
 * `#{order.orderNumber}` in JSX — it ensures exactly ONE leading `#`
 * regardless of whether the stored value already has one.
 *
 * Bug context: pre-launch QA (audit 2026-04-24) found ~8,296 migrated
 * retail orders rendered as `##19265` across admin lists, customer
 * detail, storefront order history, order-tracking, and exchange /
 * return flows. This helper closes all of them in one place.
 */
export function formatOrderNumber(
  orderNumber: string | null | undefined,
): string {
  if (!orderNumber) return "";
  return orderNumber.startsWith("#") ? orderNumber : `#${orderNumber}`;
}
